import React from 'react'

import Botao from '../../Mantine/Botao/index.jsx'
import Group from '../../Mantine/Group/index.jsx'
import Modal from '../../Mantine/Modal/index.jsx'

import * as S from './styles.js'
const MESSAGE_TYPES = {
  disableRecovery:
    'Não foi possível redefinir sua senha, pois sua conta está bloqueada. Para solicitar o desbloqueio, entre em contato com o suporte.',
  blocked: (
    <div>
      Prezado usuário, sua senha foi bloqueada devido a tentativas excessivas de
      login sem sucesso. Para redefinir sua senha e recuperar o acesso à sua
      conta, use a opção <b>Esqueci minha senha</b>.
    </div>
  ),
  inactivity: (
    <div>
      Prezado usuário, sua senha foi bloqueada devido a 30 dias de inatividade.
      Para para redefinir sua senha e recuperar o acesso à sua conta, use a
      opção <b>Esqueci minha senha</b>.
    </div>
  ),
  spam: (
    <div>
      Prezado Cliente, identificamos um volume de envios de SMS em sua conta que
      podem estar em desacordo com nossas políticas de uso e possivelmente sendo
      interpretado como SPAM. De maneira preventiva, o acesso à sua conta foi
      bloqueado. Para solicitar o desbloqueio, entre em contato com o nosso
      Suporte.
    </div>
  )
}

export default function Alerta({ opened, onClick, type }) {
  const hasRecover = !['disableRecovery', 'solicitation', 'spam'].includes(type)
  const message = MESSAGE_TYPES[type]

  return (
    <Modal
      titulo="Atenção!"
      width={'600px'}
      type="alerta"
      useWhiteTheme
      opened={opened}
      positionTitle="center"
    >
      <S.ModalAlert>
        <p className="modal-alert">{message}</p>
        <Group position="center">
          <Botao label="Fechar" onClick={() => onClick()} />
          {hasRecover && (
            <Botao
              label="Esqueci minha senha"
              onClick={() => onClick('recoverPassword')}
            />
          )}
        </Group>
      </S.ModalAlert>
    </Modal>
  )
}
